import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Popup, ScrollView, Tabs, LoadIndicator } from 'devextreme-react';
import { ToolbarItem } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import DataGrid, { Column, Editing, Item as ToolbarItemGrid, Lookup, ValidationRule } from 'devextreme-react/data-grid';
import Form, { SimpleItem, GroupItem, Label, RequiredRule } from 'devextreme-react/form';
import { useAppDispatch, useAppSelector } from '../../../../../contexts/hooks';
import { showModalMicrobiology } from '../../../../../contexts/slices/orders';
import { useScreenSize } from '../../../../../utils/media-query';
import { newToast } from '../../../..';
import { useApiResultsMicrobiology } from '../../../../../api/api.resultsmicrobiology';
import { useApiMicrobiology } from '../../../../../api/api.microbiology';
import { ResultEstadoResult } from '../../../../../types/types.orders';
import { CreateUpdateGramDTO, CreateUpdateCultivoDTO, PlantillaField, SysI_MicrobiologiaConfiguracion, CreateUpdateMicroorganismoDTO, CreateUpdateAntibiogramaDTO, MicrobiologiaReporteDTO, AlertaReporte } from '../../../../../types/types.microbiology';
import { resButtonsPin, resGridStatus1, resGridStatus2, resGridStatus3, resGridStatus4, resGridStatus5 } from '../../../../../images/icons';
import { ReportMicrobiology } from './ReportMicrobiology';

export const ModalMicrobiologyResults = () => {
  const dispatch = useAppDispatch();
  const { isMedium, isSmall, isXSmall } = useScreenSize();
  const dataModal = useAppSelector((x) => x.globalOrders.CurrentOrder.ModalResultMicrobiology);
  const Prm_ResC = useAppSelector((x) => x.userInfo.Permissions?.Prm_ResC) || false;

  const { getResultadoByResId, crearResultado, capturarGram, validarGram, capturarCultivo, validarCultivo, desvalidarGram, desvalidarCultivo, agregarMicroorganismo, actualizarMicroorganismo, eliminarMicroorganismo, validarIdentificacion, actualizarAntibiotico, eliminarAntibiotico, validarAntibiograma, getReportesByRmiId, calcularHorasTranscurridas, generarReporteManual, validarResultadoFinal } = useApiResultsMicrobiology();

  const { getConfiguracionAnalito, getMicroorganismos, getAntibioticos } = useApiMicrobiology();

  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);
  const [loadingPlantillaData, setLoadingPlantillaData] = useState(false);
  const [resultadoMicro, setResultadoMicro] = useState<any>(null);
  const [plantillaGram, setPlantillaGram] = useState<string | null>(null);
  const [camposPlantilla, setCamposPlantilla] = useState<PlantillaField[]>([]);
  const [plantillaData, setPlantillaData] = useState<any>({});
  const [configuracion, setConfiguracion] = useState<SysI_MicrobiologiaConfiguracion | null>(null);
  const [microorganismosCatalogo, setMicroorganismosCatalogo] = useState<any[]>([]);
  const [antibioticosCatalogo, setAntibioticosCatalogo] = useState<any[]>([]);
  const [selectedMicroorganismoId, setSelectedMicroorganismoId] = useState<number>(0);
  const [reportes, setReportes] = useState<MicrobiologiaReporteDTO[]>([]);
  const [reportesKey, setReportesKey] = useState(0);
  const [horasTranscurridas, setHorasTranscurridas] = useState<number>(0);
  const [alertasReporte, setAlertasReporte] = useState<AlertaReporte[]>([]);
  const [modalReporteVisible, setModalReporteVisible] = useState(false);
  const [reporteSeleccionado, setReporteSeleccionado] = useState<MicrobiologiaReporteDTO | null>(null);
  const creationAttempted = useRef(false);

  const [gramFormData, setGramFormData] = useState<CreateUpdateGramDTO>({
    Rmi_GramUsarPlantilla: false,
    Rmi_GramTipoColoracion: 'Gram',
    Rmi_GramResultado: '',
    Rmi_GramObservaciones: '',
  });

  const [cultivoFormData, setCultivoFormData] = useState<CreateUpdateCultivoDTO>({});

  const gramFormRef = useRef<Form>(null);
  const cultivoFormRef = useRef<Form>(null);
  const microorganismosGridRef = useRef<DataGrid>(null);
  const antibiogramaGridRef = useRef<DataGrid>(null);

  const loadConfiguracionYCatalogos = async () => {
    if (!dataModal?.An_Id) return;

    try {
      // Cargar configuración y catálogos en paralelo
      const [config, microorganismos, antibioticos] = await Promise.all([getConfiguracionAnalito(dataModal.An_Id), getMicroorganismos(), getAntibioticos()]);
      if (config) {
        setConfiguracion(config);
        // Cargar plantilla Gram si existe (código existente)
        if (config.Mcf_UsarPlantilla && config.Mcf_PlantillaGram) {
          setPlantillaGram(config.Mcf_PlantillaGram);
          try {
            const campos = JSON.parse(config.Mcf_PlantillaGram);
            setCamposPlantilla(campos);
          } catch (error) {
            console.error('Error parseando plantilla JSON:', error);
          }
        }
      }

      // Guardar catálogos en estado
      setMicroorganismosCatalogo(microorganismos || []);
      setAntibioticosCatalogo(antibioticos || []);
    } catch (error) {
      console.error('Error cargando configuración:', error);
    }
  };

  const loadResultadoMicrobiologia = async () => {
    if (!dataModal?.Res_Id) return;

    setLoading(true);
    try {
      const result = await getResultadoByResId(dataModal.Res_Id);
      if (result) {
        setResultadoMicro(result);
        creationAttempted.current = false;
        if (result.Gram) {
          // Marcar que está cargando plantilla
          if (configuracion?.Mcf_UsarPlantilla) {
            setLoadingPlantillaData(true);
          }

          let resultadoGram = result.Gram.Rmi_GramResultado || '';

          if (configuracion?.Mcf_UsarPlantilla && resultadoGram) {
            try {
              const parsed = JSON.parse(resultadoGram);
              setPlantillaData(parsed);
              resultadoGram = ''; // Limpiar porque los datos están en plantillaData
              // Marcar como listo después de un pequeño delay
              setTimeout(() => {
                setLoadingPlantillaData(false);
              }, 100);
            } catch (e) {
              console.error('Error parseando plantilla:', e);
              setLoadingPlantillaData(false);
            }
          } else {
            setLoadingPlantillaData(false);
          }

          setGramFormData({
            Rmi_GramUsarPlantilla: configuracion?.Mcf_UsarPlantilla || false,
            Rmi_GramTipoColoracion: result.Gram.Rmi_GramTipoColoracion || 'Gram',
            Rmi_GramResultado: resultadoGram,
            Rmi_GramObservaciones: result.Gram.Rmi_GramObservaciones || '',
          });
        }
        if (result.Cultivo) {
          setCultivoFormData({
            Rmi_CultivoResultado: result.Cultivo.Rmi_CultivoResultado,
            Rmi_CultivoTiempoCrecimiento: result.Cultivo.Rmi_CultivoTiempoCrecimiento,
            Rmi_CultivoObservaciones: result.Cultivo.Rmi_CultivoObservaciones,
          });
        }
      } else if (!creationAttempted.current) {
        creationAttempted.current = true;
        await createNewResultado();
      }
    } catch (error) {
      console.error('Error cargando resultado de microbiología:', error);
      newToast('ERROR', 'Error al cargar los datos de microbiología', 4);
      creationAttempted.current = false;
    } finally {
      setLoading(false);
    }
  };

  const loadReportes = async (rmiId: number) => {
    try {
      const rpts = await getReportesByRmiId(rmiId);
      console.log('🔍 Reportes cargados:', rpts);
      setReportes(rpts || []);
    } catch (error) {
      console.error('Error cargando reportes:', error);
    }
  };

  // Cargar configuración primero
  useEffect(() => {
    if (dataModal?.Visible && dataModal?.An_Id) {
      loadConfiguracionYCatalogos();
    }
  }, [dataModal?.Visible, dataModal?.An_Id]);

  // Cargar resultado SOLO cuando la configuración esté lista
  useEffect(() => {
    if (dataModal?.Visible && dataModal?.Res_Id && configuracion) {
      loadResultadoMicrobiologia();
    }
  }, [dataModal?.Visible, dataModal?.Res_Id, configuracion]);

  // Cargar reportes cuando se carga el resultado
  useEffect(() => {
    if (resultadoMicro?.Rmi_Id) {
      loadReportes(resultadoMicro.Rmi_Id);
      calcularTiemposYAlertas();
    }
  }, [resultadoMicro?.Rmi_Id]);

  // Actualizar tiempos cada minuto
  useEffect(() => {
    if (!resultadoMicro?.Rmi_Id) return;

    const interval = setInterval(() => {
      calcularTiemposYAlertas();
    }, 60000); // Cada minuto

    return () => clearInterval(interval);
  }, [resultadoMicro?.Rmi_Id, configuracion, reportes]);

  // AGREGAR ESTA FUNCIÓN para formatear JSON cuando se muestra como texto
  const formatearResultadoJSON = (jsonString: string): string => {
    try {
      const obj = JSON.parse(jsonString);
      return Object.entries(obj)
        .map(([key, value]) => `${key}: ${value}`)
        .join('\n');
    } catch (error) {
      return jsonString;
    }
  };

  const calcularTiemposYAlertas = async () => {
    if (!resultadoMicro?.Rmi_Id || !resultadoMicro?.Rmi_FechaCreacion) return;

    try {
      const horas = await calcularHorasTranscurridas(resultadoMicro.Rmi_Id);
      setHorasTranscurridas(horas);

      const alertas: AlertaReporte[] = [];
      const reportesExistentes = reportes.map((r) => r.Rmr_TipoReporte);

      // ═══════════════════════════════════════════════════
      // ALERTA PRELIMINAR 1 (GRAM)
      // ═══════════════════════════════════════════════════
      if (configuracion?.Mcf_TiempoReportePreliminar1 && configuracion.Mcf_TiempoReportePreliminar1 > 0 && horas >= configuracion.Mcf_TiempoReportePreliminar1 && !reportesExistentes.includes('Preliminar1') && resultadoMicro.Gram?.Rmi_GramEstado === 3) {
        alertas.push({
          tipo: 'Preliminar1',
          mensaje: `⏰ ${horas}h transcurridas. Tiempo para Reporte Preliminar 1 (GRAM)`,
          severidad: 'warning',
          puedeGenerar: true,
        });
      }

      // ═══════════════════════════════════════════════════
      // ALERTA PRELIMINAR 2 (IDENTIFICACIÓN)
      // ═══════════════════════════════════════════════════
      if (configuracion?.Mcf_TiempoReportePreliminar2 && configuracion.Mcf_TiempoReportePreliminar2 > 0 && horas >= configuracion.Mcf_TiempoReportePreliminar2 && !reportesExistentes.includes('Preliminar2') && resultadoMicro.Gram?.Rmi_GramEstado === 3 && resultadoMicro.Cultivo?.Rmi_CultivoEstado === 3) {
        const tieneIdentificacionConfirmada = resultadoMicro.Microorganismos?.some((m) => m.Mmo_EstadoIdentificacion >= 2);

        if (tieneIdentificacionConfirmada) {
          alertas.push({
            tipo: 'Preliminar2',
            mensaje: `⏰ ${horas}h transcurridas. Tiempo para Reporte Preliminar 2 (+ Identificación)`,
            severidad: 'info',
            puedeGenerar: true,
          });
        }
      }

      // ═══════════════════════════════════════════════════
      // ALERTA FINAL (ANTIBIOGRAMA)
      // ═══════════════════════════════════════════════════
      if (configuracion?.Mcf_TiempoReporteFinal && configuracion.Mcf_TiempoReporteFinal > 0 && horas >= configuracion.Mcf_TiempoReporteFinal && !reportesExistentes.includes('Final') && resultadoMicro.Rmi_EstadoGeneral === 3) {
        const todosConAntibiogramaValidado = resultadoMicro.Microorganismos?.every((m) => m.Mmo_AntibiogramaEstado === 3);

        if (todosConAntibiogramaValidado) {
          alertas.push({
            tipo: 'Final',
            mensaje: `✅ ${horas}h transcurridas. Tiempo para Reporte Final (Completo)`,
            severidad: 'success',
            puedeGenerar: true,
          });
        }
      }

      setAlertasReporte(alertas);
    } catch (error) {
      console.error('Error calculando tiempos:', error);
    }
  };

  const handleGenerarReporteManual = async (tipoReporte: 'Preliminar1' | 'Preliminar2' | 'Final') => {
    if (!resultadoMicro?.Rmi_Id) return;

    if (tipoReporte === 'Final' && resultadoMicro.Rmi_EstadoGeneral !== 3) {
      newToast('WARNING', 'El resultado no está listo para generar el reporte final', 3);
      return;
    }

    setLoading(true);
    try {
      await generarReporteManual(resultadoMicro.Rmi_Id, tipoReporte);
      await loadReportes(resultadoMicro.Rmi_Id);
      await calcularTiemposYAlertas();
      setReportesKey((prev) => prev + 1);
    } catch (error) {
      console.error('Error generando reporte:', error);
    } finally {
      setLoading(false);
    }
  };

  // AGREGAR FUNCIONES DE DESVALIDACIÓN
  const handleDesvalidarGram = async () => {
    if (!resultadoMicro?.Rmi_Id) {
      return;
    }

    if (resultadoMicro?.Gram?.Rmi_GramEstado !== 3) {
      newToast('WARNING', 'El Gram no está validado', 3);
      return;
    }

    setLoading(true);
    try {
      // Llamar a la API de desvalidación
      const result = await desvalidarGram(resultadoMicro.Rmi_Id);
      if (result) {
        setResultadoMicro(result);
        newToast('SUCCESS', 'Gram desvalidado correctamente', 3);
      }
    } catch (error) {
      console.error('Error desvalidando Gram:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDesvalidarCultivo = async () => {
    if (!resultadoMicro?.Rmi_Id) {
      return;
    }

    if (resultadoMicro?.Cultivo?.Rmi_CultivoEstado !== 3) {
      newToast('WARNING', 'El Cultivo no está validado', 3);
      return;
    }

    setLoading(true);
    try {
      const result = await desvalidarCultivo(resultadoMicro.Rmi_Id);
      if (result) {
        setResultadoMicro(result);
        newToast('SUCCESS', 'Cultivo desvalidado correctamente', 3);
      }
    } catch (error) {
      console.error('Error desvalidando Cultivo:', error);
    } finally {
      setLoading(false);
    }
  };

  const createNewResultado = async () => {
    if (!dataModal?.Res_Id || !dataModal?.An_Id) return;

    try {
      const newResultado = await crearResultado({
        Rmi_Res_Id: dataModal.Res_Id,
        Rmi_Es_Id: dataModal.Es_Id || 0,
        Rmi_An_Id: dataModal.An_Id,
        Rmi_Ord_Id: dataModal.Ord_Id || 0,
      });
      if (newResultado) {
        setResultadoMicro(newResultado);
      }
    } catch (error) {
      console.error('Error creando resultado:', error);
    }
  };

  const handleClose = useCallback(() => {
    dispatch(showModalMicrobiology({ Visible: false, An_Id: -1, An_Nombre: '', An_Plantilla: '', Res_Estado: ResultEstadoResult.Validado, Res_Id: -1, Res_Resultado: '', Update: true, Pc_Id: -1, Es_Id: -1, Ord_Id: -1 }));
    setCurrentTab(0);
    setResultadoMicro(null);
    setPlantillaGram(null);
    setCamposPlantilla([]);
    setPlantillaData({});
    setGramFormData({
      Rmi_GramUsarPlantilla: false,
      Rmi_GramTipoColoracion: 'Gram',
      Rmi_GramResultado: '',
      Rmi_GramObservaciones: '',
    });
    setCultivoFormData({});
    setLoadingPlantillaData(false);
    creationAttempted.current = false;
  }, [dispatch]);

  const handlePlantillaChange = (key: string, value: any) => {
    const newData = { ...plantillaData, [key]: value };
    setPlantillaData(newData);
    setGramFormData({
      ...gramFormData,
      Rmi_GramResultado: JSON.stringify(newData),
    });
  };

  const handleSaveGram = async () => {
    // Validar según el modo
    if (configuracion?.Mcf_UsarPlantilla) {
      // Validar que campos requeridos de la plantilla estén llenos
      const camposRequeridos = camposPlantilla.filter((c) => c.Required);
      const faltantes = camposRequeridos.filter((c) => !plantillaData[c.KeyValue]);

      if (faltantes.length > 0) {
        newToast('WARNING', `Complete los campos requeridos: ${faltantes.map((c) => c.Label).join(', ')}`, 4);
        return;
      }
    } else {
      // Validar formulario de texto libre
      if (!gramFormRef.current?.instance.validate().isValid) {
        newToast('WARNING', 'Complete los campos requeridos del Gram', 4);
        return;
      }
    }

    if (!resultadoMicro?.Rmi_Id) {
      newToast('ERROR', 'No se puede guardar sin un registro de microbiología', 4);
      return;
    }

    setLoading(true);
    try {
      const result = await capturarGram(resultadoMicro.Rmi_Id, gramFormData);
      if (result) {
        setResultadoMicro(result);
      }
    } catch (error) {
      console.error('Error guardando Gram:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleValidateGram = async () => {
    if (resultadoMicro?.Gram.Rmi_GramEstado === 0) {
      newToast('ERROR', 'Debe guardar el Gram antes de validarlo', 4);
      return;
    }
    setLoading(true);
    try {
      const result = await validarGram(resultadoMicro.Rmi_Id);
      if (result) {
        setResultadoMicro(result);
        setCurrentTab(1);
        if (configuracion?.Mcf_ReportarGramSiNegativo && gramFormData.Rmi_GramResultado?.toLowerCase().includes('negativo')) {
          newToast('INFO', 'Gram negativo - Se puede reportar inmediatamente según configuración', 4);
        }
      }
    } catch (error) {
      console.error('Error validando Gram:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveCultivo = async () => {
    if (!cultivoFormRef.current?.instance.validate().isValid) {
      newToast('WARNING', 'Complete los campos requeridos del Cultivo', 4);
      return;
    }

    setLoading(true);
    try {
      const result = await capturarCultivo(resultadoMicro.Rmi_Id, cultivoFormData);
      if (result) {
        setResultadoMicro(result);
      }
    } catch (error) {
      console.error('Error guardando Cultivo:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleValidateCultivo = async () => {
    if (resultadoMicro?.Cultivo.Rmi_CultivoEstado === 0) {
      newToast('ERROR', 'Debe guardar el Cultivo antes de validarlo', 4);
      return;
    }

    setLoading(true);
    try {
      const result = await validarCultivo(resultadoMicro.Rmi_Id);
      if (result) {
        setResultadoMicro(result);

        // Verificar si cultivo negativo se reporta inmediatamente
        if (configuracion?.Mcf_ReportarCultivoNegativoInmediato && cultivoFormData.Rmi_CultivoResultado === 'Negativo') {
          newToast('INFO', 'Cultivo negativo - Se puede reportar inmediatamente según configuración', 4);
        }
        if (result.Cultivo?.Rmi_CultivoResultado === 'Positivo') {
          setCurrentTab(2);
        } else {
          newToast('INFO', 'Cultivo negativo - Proceso finalizado', 4);
        }
      }
    } catch (error) {
      console.error('Error validando Cultivo:', error);
    } finally {
      setLoading(false);
    }
  };

  // ====================================================================
  // IDENTIFICACIÓN - MICROORGANISMOS
  // ====================================================================

  const handleAgregarMicroorganismo = async () => {
    if (!resultadoMicro?.Rmi_Id) return;

    // Verificar configuración
    if (configuracion && !configuracion.Mcf_HabilitarIdentificacion) {
      newToast('WARNING', 'La identificación no está habilitada en la configuración', 3);
      return;
    }

    // En lugar de agregar directamente con ID 0, usa el método addRow del DataGrid
    microorganismosGridRef.current?.instance.addRow();
  };

  const handleInsertMicroorganismo = async (e: any) => {
    const newData = e.data;

    // Validar que se haya seleccionado un microorganismo
    if (!newData.Mmo_Moc_Id) {
      e.cancel = true;
      newToast('WARNING', 'Debe seleccionar un microorganismo del catálogo', 3);
      return;
    }

    setLoading(true);
    try {
      const nuevoMicro: CreateUpdateMicroorganismoDTO = {
        Mmo_Moc_Id: newData.Mmo_Moc_Id,
        Mmo_Recuento: newData.Mmo_Recuento || '',
        Mmo_RecuentoNumerico: newData.Mmo_RecuentoNumerico || undefined,
        Mmo_MetodoIdentificacion: newData.Mmo_MetodoIdentificacion || undefined,
        Mmo_Comentario: newData.Mmo_Comentario || '',
        Mmo_Orden: (resultadoMicro.Microorganismos?.length || 0) + 1,
      };

      const result = await agregarMicroorganismo(resultadoMicro.Rmi_Id, nuevoMicro);
      if (result) {
        await loadResultadoMicrobiologia();
        newToast('SUCCESS', 'Microorganismo agregado correctamente', 3);
      }
    } catch (error) {
      console.error('Error agregando microorganismo:', error);
      e.cancel = true; // Cancela la inserción en el grid si falla
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateMicroorganismo = async (e: any) => {
    const mmoId = e.key;
    const changes = e.newData;

    setLoading(true);
    try {
      const microActual = resultadoMicro.Microorganismos.find((m: any) => m.Mmo_Id === mmoId);
      const dataToUpdate: CreateUpdateMicroorganismoDTO = {
        Mmo_Moc_Id: changes.Mmo_Moc_Id ?? microActual.Mmo_Moc_Id,
        Mmo_Recuento: changes.Mmo_Recuento ?? microActual.Mmo_Recuento,
        Mmo_RecuentoNumerico: changes.Mmo_RecuentoNumerico ?? microActual.Mmo_RecuentoNumerico,
        Mmo_MetodoIdentificacion: changes.Mmo_MetodoIdentificacion ?? microActual.Mmo_MetodoIdentificacion,
        Mmo_Comentario: changes.Mmo_Comentario ?? microActual.Mmo_Comentario,
        Mmo_Orden: microActual.Mmo_Orden,
      };

      await actualizarMicroorganismo(mmoId, dataToUpdate);
      await loadResultadoMicrobiologia();
    } catch (error) {
      console.error('Error actualizando microorganismo:', error);
      throw error; // Importante para que DevExtreme maneje el error
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMicroorganismo = async (e: any) => {
    const mmoId = e.key;

    setLoading(true);
    try {
      await eliminarMicroorganismo(mmoId);
      await loadResultadoMicrobiologia();
      newToast('SUCCESS', 'Microorganismo eliminado', 3);
    } catch (error) {
      console.error('Error eliminando microorganismo:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleValidarIdentificacion = async (mmoId: number) => {
    setLoading(true);
    try {
      await validarIdentificacion(mmoId);
      await loadResultadoMicrobiologia();
      newToast('SUCCESS', 'Identificación validada', 3);
    } catch (error) {
      console.error('Error validando identificación:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSeleccionMicroorganismo = (e: any) => {
    if (e.selectedRowKeys && e.selectedRowKeys.length > 0) {
      setSelectedMicroorganismoId(e.selectedRowKeys[0]);
    } else {
      setSelectedMicroorganismoId(0);
    }
  };

  // ====================================================================
  // ANTIBIOGRAMA
  // ====================================================================

  const handleSaveAntibiograma = async () => {
    if (!selectedMicroorganismoId) {
      newToast('WARNING', 'Seleccione un microorganismo', 3);
      return;
    }

    const microSeleccionado = resultadoMicro.Microorganismos?.find((m: any) => m.Mmo_Id === selectedMicroorganismoId);

    if (!microSeleccionado?.Antibiograma || microSeleccionado.Antibiograma.length === 0) {
      newToast('WARNING', 'No hay antibióticos para guardar', 3);
      return;
    }

    // Validar que todos tengan interpretación
    const sinInterpretacion = microSeleccionado.Antibiograma.filter((a: any) => !a.Mab_Interpretacion || a.Mab_Interpretacion.trim() === '');

    if (sinInterpretacion.length > 0) {
      newToast('WARNING', `Hay ${sinInterpretacion.length} antibiótico(s) sin interpretación`, 3);
      return;
    }

    setLoading(true);
    try {
      // Guardar todos los antibióticos modificados
      const promises = microSeleccionado.Antibiograma.map((antibiotico: any) => {
        const dto: CreateUpdateAntibiogramaDTO = {
          Mab_Abc_Id: antibiotico.Mab_Abc_Id,
          Mab_Interpretacion: antibiotico.Mab_Interpretacion,
          Mab_MIC: antibiotico.Mab_MIC,
          Mab_DiametroDisco: antibiotico.Mab_DiametroDisco,
          Mab_MetodoPrueba: antibiotico.Mab_MetodoPrueba,
          Mab_Comentarios: antibiotico.Mab_ComentarioExperto,
          Mab_Orden: antibiotico.Mab_Orden,
        };
        return actualizarAntibiotico(antibiotico.Mab_Id, dto);
      });

      await Promise.all(promises);
      await loadResultadoMicrobiologia();
      newToast('SUCCESS', 'Antibiograma guardado correctamente', 3);
    } catch (error) {
      console.error('Error guardando antibiograma:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAntibiotico = async (e: any) => {
    const mabId = e.key;

    setLoading(true);
    try {
      await eliminarAntibiotico(mabId);
      await loadResultadoMicrobiologia();
      newToast('SUCCESS', 'Antibiótico eliminado', 3);
    } catch (error) {
      console.error('Error eliminando antibiótico:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleValidarAntibiograma = async () => {
    if (!selectedMicroorganismoId) {
      newToast('WARNING', 'Seleccione un microorganismo', 3);
      return;
    }

    setLoading(true);
    try {
      await validarAntibiograma(selectedMicroorganismoId);
      await loadResultadoMicrobiologia();
      newToast('SUCCESS', 'Antibiograma validado', 3);
    } catch (error) {
      console.error('Error validando antibiograma:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderPlantillaFields = () => {
    if (!camposPlantilla || camposPlantilla.length === 0) {
      return (
        <div style={{ padding: '20px', textAlign: 'center', backgroundColor: '#fff3cd', borderRadius: '8px', marginTop: '15px' }}>
          <p style={{ margin: 0, color: '#856404' }}>No hay plantilla configurada para este analito.</p>
        </div>
      );
    }

    const grupos = camposPlantilla.reduce((acc, campo) => {
      if (!acc[campo.Group]) {
        acc[campo.Group] = [];
      }
      acc[campo.Group].push(campo);
      return acc;
    }, {} as Record<string, PlantillaField[]>);

    const isValidated = resultadoMicro?.Gram?.Rmi_GramEstado === 3;

    return (
      <div style={{ marginTop: '15px' }}>
        {Object.entries(grupos).map(([grupo, campos]) => (
          <div key={grupo} style={{ marginBottom: '20px' }}>
            <h5 style={{ marginBottom: '15px', color: '#007acc', borderBottom: '1px solid #e0e0e0', paddingBottom: '8px' }}>{grupo}</h5>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
              {campos.map((campo) => (
                <div key={campo.KeyValue}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 500, fontSize: '13px' }}>
                    {campo.Label}
                    {campo.Required && <span style={{ color: 'red' }}> *</span>}
                  </label>
                  {campo.Type === 'dxSelectBox' && (
                    <select
                      value={plantillaData[campo.KeyValue] || ''}
                      onChange={(e) => handlePlantillaChange(campo.KeyValue, e.target.value)}
                      disabled={!Prm_ResC || isValidated}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        fontSize: '14px',
                        backgroundColor: !Prm_ResC || isValidated ? '#f5f5f5' : 'white',
                      }}>
                      <option value=''>Seleccione...</option>
                      {campo.Items?.map((item) => (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  )}
                  {campo.Type === 'dxTextBox' && (
                    <input
                      type='text'
                      value={plantillaData[campo.KeyValue] || ''}
                      onChange={(e) => handlePlantillaChange(campo.KeyValue, e.target.value)}
                      disabled={!Prm_ResC || isValidated}
                      placeholder={campo.Placeholder}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        fontSize: '14px',
                        backgroundColor: !Prm_ResC || isValidated ? '#f5f5f5' : 'white',
                      }}
                    />
                  )}
                  {campo.Type === 'dxTextArea' && (
                    <textarea
                      value={plantillaData[campo.KeyValue] || ''}
                      onChange={(e) => handlePlantillaChange(campo.KeyValue, e.target.value)}
                      disabled={!Prm_ResC || isValidated}
                      placeholder={campo.Placeholder}
                      rows={3}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        fontSize: '14px',
                        resize: 'vertical',
                        backgroundColor: !Prm_ResC || isValidated ? '#f5f5f5' : 'white',
                      }}
                    />
                  )}
                  {campo.Type === 'dxNumberBox' && (
                    <input
                      type='number'
                      value={plantillaData[campo.KeyValue] || ''}
                      onChange={(e) => handlePlantillaChange(campo.KeyValue, e.target.value)}
                      disabled={!Prm_ResC || isValidated}
                      min={campo.Min}
                      max={campo.Max}
                      placeholder={campo.Placeholder}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        fontSize: '14px',
                        backgroundColor: !Prm_ResC || isValidated ? '#f5f5f5' : 'white',
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const getIconStatus = () => {
    switch (dataModal?.Res_Estado) {
      case ResultEstadoResult.SinResultado:
      default:
        return resGridStatus1;
      case ResultEstadoResult.ConResultado:
        return resGridStatus2;
      case ResultEstadoResult.Validado:
        return resGridStatus3;
      case ResultEstadoResult.Impreso:
        return resGridStatus4;
      case ResultEstadoResult.OtrasFuentes:
        return resGridStatus5;
      case ResultEstadoResult.ValidadoBlanco:
        return resButtonsPin;
    }
  };

  const getTextStatus = () => {
    switch (dataModal?.Res_Estado) {
      case ResultEstadoResult.SinResultado:
      default:
        return 'SIN RESULTADO';
      case ResultEstadoResult.ConResultado:
        return 'CON RESULTADO';
      case ResultEstadoResult.Validado:
        return 'VALIDADO';
      case ResultEstadoResult.Impreso:
        return 'IMPRESO';
      case ResultEstadoResult.OtrasFuentes:
        return 'OTRAS FUENTES';
      case ResultEstadoResult.ValidadoBlanco:
        return 'VALIDADO EN BLANCO';
    }
  };

  const handleVerReporte = (reporte: MicrobiologiaReporteDTO) => {
    setReporteSeleccionado(reporte);
    setModalReporteVisible(true);
  };

  const handleValidarFinal = async () => {
    if (!resultadoMicro?.Rmi_Id) return;

    // Validaciones previas
    if (resultadoMicro?.Gram?.Rmi_GramEstado !== 3) {
      newToast('WARNING', 'Debe validar el GRAM primero', 3);
      return;
    }

    if (resultadoMicro?.Cultivo?.Rmi_CultivoEstado !== 3) {
      newToast('WARNING', 'Debe validar el CULTIVO primero', 3);
      return;
    }

    // Si cultivo positivo, validar microorganismos
    if (resultadoMicro?.Cultivo?.Rmi_CultivoResultado === 'Positivo') {
      if (!resultadoMicro?.Microorganismos || resultadoMicro.Microorganismos.length === 0) {
        newToast('WARNING', 'Debe agregar al menos un microorganismo', 3);
        return;
      }

      // Validar que todos tengan identificación confirmada
      const todosConfirmados = resultadoMicro.Microorganismos.every((m) => m.Mmo_EstadoIdentificacion === 3);
      if (!todosConfirmados) {
        newToast('WARNING', 'Todos los microorganismos deben tener identificación confirmada', 3);
        return;
      }

      // Validar que todos tengan antibiograma validado
      const todosConAntibiograma = resultadoMicro.Microorganismos.every((m) => m.Mmo_AntibiogramaEstado === 3);
      if (!todosConAntibiograma) {
        newToast('WARNING', 'Todos los microorganismos deben tener antibiograma validado', 3);
        return;
      }
    }

    setLoading(true);
    try {
      const result = await validarResultadoFinal(resultadoMicro.Rmi_Id);
      if (result) {
        setResultadoMicro(result);
        await calcularTiemposYAlertas();
        newToast('SUCCESS', 'Resultado validado correctamente. Ahora puede generar el reporte final.', 4);
      }
    } catch (error) {
      console.error('Error validando resultado final:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!dataModal?.Visible) return null;

  const isGramValidated = resultadoMicro?.Gram?.Rmi_GramEstado === 3;
  const isCultivoValidated = resultadoMicro?.Cultivo?.Rmi_CultivoEstado === 3;

  return (
    <Popup visible={dataModal.Visible} onHiding={handleClose} dragEnabled={false} hideOnOutsideClick={false} showCloseButton={false} showTitle={true} title='RESULTADOS DE MICROBIOLOGÍA' width={isXSmall ? '100%' : isSmall ? '95%' : isMedium ? '85%' : '75%'} height={isXSmall || isSmall ? '100%' : '85%'}>
      <ToolbarItem
        widget='dxButton'
        toolbar='top'
        location='before'
        options={{
          icon: getIconStatus(),
          text: getTextStatus(),
          disabled: true,
          stylingMode: 'text',
        }}
      />
      <ToolbarItem
        widget='dxButton'
        toolbar='top'
        location='after'
        options={{
          icon: 'close',
          onClick: handleClose,
        }}
      />

      {loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '400px' }}>
          <LoadIndicator visible={true} />
          <p style={{ marginTop: '20px' }}>Cargando información de microbiología...</p>
        </div>
      ) : (
        <ScrollView width='100%' height='100%'>
          <div style={{ padding: '20px' }}>
            <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
              <h3 style={{ margin: '0 0 10px 0' }}>{dataModal?.An_Nombre}</h3>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <span style={{ padding: '5px 15px', borderRadius: '15px', backgroundColor: isGramValidated ? '#28a745' : '#ffc107', color: 'white', fontSize: '12px', fontWeight: 'bold' }}>Gram: {isGramValidated ? 'Validado' : 'Pendiente'}</span>
                <span style={{ padding: '5px 15px', borderRadius: '15px', backgroundColor: isCultivoValidated ? '#28a745' : '#6c757d', color: 'white', fontSize: '12px', fontWeight: 'bold' }}>Cultivo: {isCultivoValidated ? 'Validado' : 'Pendiente'}</span>
                {/* Información de tiempos de reporte */}
                {resultadoMicro?.Cultivo?.Rmi_CultivoResultado === 'Positivo' && (
                  <span
                    style={{
                      padding: '5px 15px',
                      borderRadius: '15px',
                      backgroundColor: '#ff9800',
                      color: 'white',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      boxShadow: '0 2px 8px rgba(255, 152, 0, 0.4)',
                    }}>
                    ⚠ POSITIVO
                  </span>
                )}
              </div>
            </div>
            {/* ═══════════════════════════════════════════════════════ */}
            {/* PANEL DE TIEMPOS Y ALERTAS */}
            {/* ═══════════════════════════════════════════════════════ */}
            {resultadoMicro && configuracion && (
              <div
                style={{
                  padding: '15px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  marginBottom: '15px',
                  border: '1px solid #dee2e6',
                }}>
                {/* INDICADOR DE TIEMPO */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                    marginBottom: '10px',
                  }}>
                  <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    Tiempo transcurrido: <span style={{ color: '#007acc' }}>{horasTranscurridas}h</span>
                  </span>
                  {(configuracion.Mcf_TiempoReportePreliminar1 ?? 0) > 0 && <span style={{ fontSize: '13px', color: '#666' }}>| P1: {configuracion.Mcf_TiempoReportePreliminar1}h</span>}
                  {(configuracion.Mcf_TiempoReportePreliminar2 ?? 0) > 0 && <span style={{ fontSize: '13px', color: '#666' }}>| P2: {configuracion.Mcf_TiempoReportePreliminar2}h</span>}
                  {(configuracion.Mcf_TiempoReporteFinal ?? 0) > 0 && <span style={{ fontSize: '13px', color: '#666' }}>| Final: {configuracion.Mcf_TiempoReporteFinal}h</span>}
                </div>

                {/* ALERTAS AUTOMÁTICAS */}
                {alertasReporte.length > 0 && (
                  <div style={{ marginTop: '10px' }}>
                    {alertasReporte.map((alerta, idx) => (
                      <div
                        key={idx}
                        style={{
                          padding: '10px',
                          marginBottom: '8px',
                          backgroundColor: alerta.severidad === 'warning' ? '#fff3cd' : alerta.severidad === 'info' ? '#d1ecf1' : '#d4edda',
                          border: `1px solid ${alerta.severidad === 'warning' ? '#ffc107' : alerta.severidad === 'info' ? '#17a2b8' : '#28a745'}`,
                          borderRadius: '4px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}>
                        <span style={{ fontSize: '14px' }}>{alerta.mensaje}</span>
                        {alerta.puedeGenerar && Prm_ResC && <Button text='Generar Ahora' type='default' stylingMode='contained' onClick={() => handleGenerarReporteManual(alerta.tipo)} />}
                      </div>
                    ))}
                  </div>
                )}

                {/* REPORTES GENERADOS */}
                {reportes.length > 0 && (
                  <div style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
                    <strong>Reportes generados:</strong>{' '}
                    {reportes.map((r) => (
                      <span
                        key={r.Rmr_Id}
                        style={{
                          display: 'inline-block',
                          padding: '4px 8px',
                          margin: '0 5px',
                          backgroundColor: '#e7f3ff',
                          borderRadius: '4px',
                          fontSize: '12px',
                        }}>
                        {r.Rmr_TipoReporte} ({r.Rmr_HorasTranscurridas}h)
                      </span>
                    ))}
                  </div>
                )}
              </div>
            )}

            <Tabs
              dataSource={[
                { id: 0, text: 'GRAM', icon: 'share' },
                { id: 1, text: 'CULTIVO', icon: 'showpanel' },
                { id: 2, text: 'IDENTIFICACIÓN', icon: 'search', disabled: !resultadoMicro?.Cultivo || resultadoMicro?.Cultivo?.Rmi_CultivoResultado !== 'Positivo' },
                { id: 3, text: 'ANTIBIOGRAMA', icon: 'bulletlist', disabled: !resultadoMicro?.Cultivo || resultadoMicro?.Cultivo?.Rmi_CultivoResultado !== 'Positivo' },
                { id: 4, text: 'REPORTES', icon: 'exportpdf' },
              ]}
              selectedIndex={currentTab}
              onItemClick={(e) => setCurrentTab(e.itemIndex)}
              showNavButtons={true}
            />

            <div style={{ marginTop: '20px' }}>
              {currentTab === 0 && (
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h4 style={{ margin: 0 }}>EXAMEN DIRECTO - COLORACIÓN GRAM</h4>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 500 }}>
                      Tipo de Coloración <span style={{ color: 'red' }}>*</span>
                    </label>
                    <select
                      value={gramFormData.Rmi_GramTipoColoracion || 'Gram'}
                      onChange={(e) => setGramFormData({ ...gramFormData, Rmi_GramTipoColoracion: e.target.value })}
                      disabled={!Prm_ResC || isGramValidated}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        fontSize: '14px',
                        backgroundColor: !Prm_ResC || isGramValidated ? '#f5f5f5' : 'white',
                      }}>
                      <option value='Gram'>Gram</option>
                      <option value='Ziehl-Neelsen'>Ziehl-Neelsen</option>
                      <option value='KOH'>KOH</option>
                    </select>
                  </div>

                  {loadingPlantillaData ? (
                    <div style={{ padding: '20px', textAlign: 'center', backgroundColor: '#e3f2fd', borderRadius: '8px', marginTop: '15px' }}>
                      <p style={{ margin: 0, color: '#1976d2' }}>⏳ Cargando plantilla...</p>
                    </div>
                  ) : configuracion?.Mcf_UsarPlantilla && Object.keys(plantillaData).length > 0 && resultadoMicro?.Rmi_GramResultado ? (
                    renderPlantillaFields()
                  ) : configuracion?.Mcf_UsarPlantilla ? (
                    renderPlantillaFields()
                  ) : (
                    <div>
                      {/* Si es JSON guardado pero no está usando plantilla, mostrar formateado */}
                      {gramFormData.Rmi_GramResultado && gramFormData.Rmi_GramResultado.startsWith('{') ? (
                        <div style={{ marginTop: '15px' }}>
                          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 500 }}>Resultado Microscópico</label>
                          <div
                            style={{
                              padding: '10px',
                              backgroundColor: '#f8f9fa',
                              border: '1px solid #ddd',
                              borderRadius: '4px',
                              fontSize: '14px',
                              whiteSpace: 'pre-wrap',
                              fontFamily: 'monospace',
                            }}>
                            {formatearResultadoJSON(gramFormData.Rmi_GramResultado)}
                          </div>
                          {!isGramValidated && Prm_ResC && (
                            <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#fff3cd', borderRadius: '4px', fontSize: '13px' }}>
                              <strong>Nota:</strong> Este resultado fue guardado usando una plantilla. Active "Usar plantilla estructurada" para editarlo.
                            </div>
                          )}
                        </div>
                      ) : (
                        <Form
                          ref={gramFormRef}
                          formData={gramFormData}
                          onFieldDataChanged={(e) => {
                            setGramFormData({ ...gramFormData, [e.dataField as string]: e.value });
                          }}
                          labelLocation='top'
                          readOnly={!Prm_ResC || isGramValidated}>
                          <SimpleItem
                            dataField='Rmi_GramResultado'
                            editorType='dxTextArea'
                            editorOptions={{
                              height: 150,
                              placeholder: 'Describa el resultado microscópico...',
                            }}>
                            <Label text='Resultado Microscópico' />
                            <RequiredRule message='Campo requerido' />
                          </SimpleItem>
                        </Form>
                      )}
                    </div>
                  )}

                  <div style={{ marginTop: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 500 }}>Observaciones</label>
                    <textarea
                      value={gramFormData.Rmi_GramObservaciones || ''}
                      onChange={(e) => setGramFormData({ ...gramFormData, Rmi_GramObservaciones: e.target.value })}
                      disabled={!Prm_ResC || isGramValidated}
                      placeholder='Observaciones adicionales'
                      rows={3}
                      style={{
                        width: '100%',
                        padding: '8px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        fontSize: '14px',
                        resize: 'vertical',
                        backgroundColor: !Prm_ResC || isGramValidated ? '#f5f5f5' : 'white',
                      }}
                    />
                  </div>

                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      display: 'flex',
                      gap: '10px',
                      justifyContent: 'flex-end',
                      padding: '15px 20px',
                      backgroundColor: 'white',
                      borderTop: '1px solid #e0e0e0',
                      zIndex: 10,
                    }}>
                    {isGramValidated && Prm_ResC && <Button text='Desvalidar Gram' type='danger' icon='revert' onClick={handleDesvalidarGram} disabled={loading} />}
                    <Button text='CONFIRMAR GRAM' type='default' onClick={handleSaveGram} disabled={!Prm_ResC || isGramValidated || loading} />
                    <Button style={{ backgroundColor: '#28a745', borderColor: '#28a745', color: 'white' }} text='Validar Gram' type='success' icon='check' onClick={handleValidateGram} disabled={!Prm_ResC || !resultadoMicro?.Gram || resultadoMicro?.Gram?.Rmi_GramEstado === 0 || isGramValidated || loading} />
                  </div>
                </div>
              )}

              {currentTab === 1 && (
                <div>
                  <h4 style={{ marginBottom: '20px' }}>CULTIVO MICROBIOLÓGICO</h4>
                  <Form
                    ref={cultivoFormRef}
                    formData={cultivoFormData}
                    onFieldDataChanged={(e) => {
                      setCultivoFormData({ ...cultivoFormData, [e.dataField as string]: e.value });
                    }}
                    labelLocation='top'
                    readOnly={!Prm_ResC || isCultivoValidated}>
                    <GroupItem colCount={2}>
                      <SimpleItem
                        dataField='Rmi_CultivoResultado'
                        editorType='dxSelectBox'
                        editorOptions={{
                          items: ['Positivo', 'Negativo', 'Contaminado'],
                          placeholder: 'Seleccione resultado',
                        }}>
                        <Label text='Resultado del Cultivo' />
                        <RequiredRule message='Campo requerido' />
                      </SimpleItem>

                      <SimpleItem
                        dataField='Rmi_CultivoTiempoCrecimiento'
                        editorType='dxNumberBox'
                        editorOptions={{
                          min: 0,
                          placeholder: 'Horas de crecimiento',
                        }}>
                        <Label text='Tiempo de Crecimiento (hrs)' />
                      </SimpleItem>
                    </GroupItem>

                    <SimpleItem
                      dataField='Rmi_CultivoObservaciones'
                      editorType='dxTextArea'
                      editorOptions={{
                        height: 100,
                        placeholder: 'Observaciones adicionales (opcional)...',
                      }}>
                      <Label text='Observaciones' />
                    </SimpleItem>
                  </Form>

                  {resultadoMicro?.Cultivo?.Rmi_CultivoResultado && (
                    <div
                      style={{
                        marginTop: '15px',
                        padding: '18px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        // Colores según el resultado
                        backgroundColor:
                          resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Positivo'
                            ? '#fff3e0' // Naranja claro (alerta)
                            : resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Negativo'
                            ? '#e8f5e9' // Verde claro (todo bien)
                            : '#ffebee', // Rojo claro (contaminado)
                        border: `3px solid ${
                          resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Positivo'
                            ? '#ff9800' // Naranja fuerte (alerta)
                            : resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Negativo'
                            ? '#4caf50' // Verde (todo bien)
                            : '#f44336' // Rojo (contaminado)
                        }`,
                        boxShadow:
                          resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Positivo'
                            ? '0 2px 8px rgba(255, 152, 0, 0.3)' // Sombra naranja para destacar
                            : 'none',
                      }}>
                      {/* Icono según el resultado */}
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '20px',
                          backgroundColor: resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Positivo' ? '#ff9800' : resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Negativo' ? '#4caf50' : '#f44336',
                          color: 'white',
                          fontWeight: 'bold',
                          flexShrink: 0,
                        }}>
                        {resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Positivo' ? '⚠' : resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Negativo' ? '✓' : '✕'}
                      </div>

                      {/* Texto del resultado */}
                      <div style={{ flex: 1 }}>
                        <div
                          style={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color:
                              resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Positivo'
                                ? '#e65100' // Naranja oscuro
                                : resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Negativo'
                                ? '#2e7d32' // Verde oscuro
                                : '#c62828', // Rojo oscuro
                            marginBottom: '4px',
                          }}>
                          Resultado del Cultivo: {resultadoMicro.Cultivo.Rmi_CultivoResultado.toUpperCase()}
                        </div>

                        {/* Mensaje adicional según el resultado */}
                        <div
                          style={{
                            fontSize: '13px',
                            color: '#666',
                            fontStyle: 'italic',
                          }}>
                          {resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Positivo' && '⚠️ Se detectó crecimiento bacteriano - Continuar con identificación y antibiograma'}
                          {resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Negativo' && '✓ No se detectó crecimiento bacteriano - Proceso finalizado'}
                          {resultadoMicro.Cultivo.Rmi_CultivoResultado === 'Contaminado' && '✕ Muestra contaminada - Se requiere nueva muestra'}
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      display: 'flex',
                      gap: '10px',
                      justifyContent: 'flex-end',
                      padding: '15px 20px',
                      backgroundColor: 'white',
                      borderTop: '1px solid #e0e0e0',
                      zIndex: 10,
                    }}>
                    {isCultivoValidated && Prm_ResC && <Button text='Desvalidar Cultivo' type='danger' icon='revert' onClick={handleDesvalidarCultivo} disabled={loading} />}
                    <Button text='CONFIRMAR CULTIVO' type='default' onClick={handleSaveCultivo} disabled={!Prm_ResC || isCultivoValidated || loading} />
                    <Button style={{ backgroundColor: '#28a745', borderColor: '#28a745', color: 'white' }} text='Validar Cultivo' type='success' icon='check' onClick={handleValidateCultivo} disabled={!Prm_ResC || !resultadoMicro?.Cultivo || resultadoMicro?.Cultivo?.Rmi_CultivoEstado === 0 || isCultivoValidated || loading} />
                  </div>
                </div>
              )}

              {currentTab === 2 && (
                <div>
                  <h4 style={{ marginBottom: '15px' }}>IDENTIFICACIÓN DE MICROORGANISMOS</h4>

                  {configuracion && !configuracion.Mcf_HabilitarIdentificacion ? (
                    <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#fff3cd', borderRadius: '8px' }}>
                      <p style={{ color: '#856404', margin: 0 }}>⚠️ La identificación no está habilitada en la configuración de este analito</p>
                    </div>
                  ) : (
                    <>
                      <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                        <Button text='Agregar Microorganismo' icon='plus' type='default' onClick={handleAgregarMicroorganismo} disabled={!Prm_ResC || loading} />
                      </div>

                      <DataGrid ref={microorganismosGridRef} dataSource={resultadoMicro?.Microorganismos || []} keyExpr='Mmo_Id' showBorders={true} showRowLines={true} width={'100%'} selection={{ mode: 'single' }} onSelectionChanged={handleSeleccionMicroorganismo} onRowInserting={handleInsertMicroorganismo} onRowUpdating={handleUpdateMicroorganismo} onRowRemoving={handleDeleteMicroorganismo} disabled={!Prm_ResC}>
                        <Editing mode='row' allowUpdating={Prm_ResC} allowDeleting={Prm_ResC} useIcons={true} />

                        <Column dataField='Mmo_Orden' caption='Orden' width={80} allowEditing={false} />

                        <Column dataField='Mmo_Moc_Id' caption='Microorganismo' width={250}>
                          <Lookup dataSource={microorganismosCatalogo} valueExpr='Moc_Id' displayExpr='Moc_Nombre' />
                          <ValidationRule type='required' message='Requerido' />
                        </Column>

                        <Column dataField='Mmo_Recuento' caption='Recuento' width={300} />
                        <Column dataField='Mmo_Comentario' caption='Comentario' width={300} />

                        <Column
                          dataField='Mmo_EstadoIdentificacion'
                          caption='Estado'
                          width={120}
                          allowEditing={false}
                          cellRender={(cellData: any) => {
                            const estado = cellData.value;
                            return (
                              <span
                                style={{
                                  padding: '4px 8px',
                                  borderRadius: '4px',
                                  fontSize: '12px',
                                  fontWeight: 500,
                                  backgroundColor: estado === 3 ? '#4caf50' : estado === 2 ? '#ff9800' : '#ccc',
                                  color: 'white',
                                }}>
                                {estado === 3 ? 'Validado' : 'Pendiente'}
                              </span>
                            );
                          }}
                        />

                        <Column
                          type='buttons'
                          width={150}
                          buttons={[
                            {
                              hint: 'Validar Identificación',
                              icon: 'check',
                              visible: (e: any) => e.row.data.Mmo_EstadoIdentificacion !== undefined && e.row.data.Mmo_EstadoIdentificacion !== 3 && Prm_ResC,
                              onClick: (e: any) => handleValidarIdentificacion(e.row.data.Mmo_Id),
                            },
                            'edit',
                            'delete',
                          ]}
                        />
                      </DataGrid>

                      {(!resultadoMicro?.Microorganismos || resultadoMicro.Microorganismos.length === 0) && (
                        <div
                          style={{
                            textAlign: 'center',
                            padding: '40px',
                            color: '#999',
                            backgroundColor: '#f9f9f9',
                            borderRadius: '8px',
                            marginTop: '20px',
                          }}>
                          No hay microorganismos registrados. Agregue el primer microorganismo aislado.
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}

              {currentTab === 3 && (
                <div>
                  <h4 style={{ marginBottom: '15px' }}>ANTIBIOGRAMA</h4>

                  {configuracion && !configuracion.Mcf_HabilitarAntibiograma ? (
                    <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#fff3cd', borderRadius: '8px' }}>
                      <p style={{ color: '#856404', margin: 0 }}>⚠️ El antibiograma no está habilitado en la configuración de este analito</p>
                    </div>
                  ) : selectedMicroorganismoId ? (
                    <>
                      <div
                        style={{
                          marginBottom: '15px',
                          padding: '10px',
                          backgroundColor: '#e3f2fd',
                          borderRadius: '4px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}>
                        <div>
                          <strong>Microorganismo seleccionado:</strong> {resultadoMicro?.Microorganismos?.find((m: any) => m.Mmo_Id === selectedMicroorganismoId)?.MicroorganismoCatalogo?.Moc_Nombre || 'Sin especificar'}
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <Button text='CONFIRMAR ANTIBIOGRAMA' type='default' onClick={handleSaveAntibiograma} disabled={!Prm_ResC || loading} />
                          <Button style={{ backgroundColor: '#28a745', color: '#fff' }} text='VALIDAR ANTIBIOGRAMA' icon='check' type='success' onClick={handleValidarAntibiograma} disabled={!Prm_ResC || loading} />
                        </div>
                      </div>

                      {/* Info de panel automático */}
                      {configuracion && (configuracion.Mcf_PanelAntibioticosGramPositivos || configuracion.Mcf_PanelAntibioticosGramNegativos) && (
                        <div
                          style={{
                            marginBottom: '15px',
                            padding: '10px',
                            backgroundColor: '#d4edda',
                            borderRadius: '4px',
                            fontSize: '12px',
                            borderLeft: '4px solid #28a745',
                          }}>
                          ℹ️ <strong>Panel automático:</strong> Los antibióticos se agregaron automáticamente según la configuración del tipo Gram. Complete las interpretaciones y guarde.
                        </div>
                      )}

                      <DataGrid ref={antibiogramaGridRef} dataSource={resultadoMicro?.Microorganismos?.find((m: any) => m.Mmo_Id === selectedMicroorganismoId)?.Antibiograma || []} keyExpr='Mab_Id' showBorders={true} showRowLines={true} width={'100%'} onRowRemoving={handleDeleteAntibiotico} disabled={!Prm_ResC}>
                        <Editing mode='batch' allowUpdating={Prm_ResC} allowDeleting={Prm_ResC} useIcons={true} />

                        <Column dataField='Mab_Orden' caption='#' width={50} allowEditing={false} />

                        <Column
                          dataField='Mab_Abc_Id'
                          caption='Antibiótico'
                          allowEditing={false}
                          width={200}
                          alignment='left'
                          cellRender={(cellData: any) => {
                            const antibiotico = antibioticosCatalogo.find((a: any) => a.Abc_Id === cellData.value);
                            return antibiotico?.Abc_Nombre || 'N/A';
                          }}
                        />

                        <Column dataField='Mab_DiametroDisco' caption='Halo (mm)' width={100} dataType='number' visible={false} />
                        <Column dataField='Mab_MIC' caption='MIC' width={100} dataType='string' />

                        <Column dataField='Mab_Interpretacion' caption='Interpretación' width={150}>
                          <Lookup
                            dataSource={[
                              { value: 'S', text: 'Sensible' },
                              { value: 'I', text: 'Intermedio' },
                              { value: 'R', text: 'Resistente' },
                            ]}
                            valueExpr='value'
                            displayExpr='text'
                          />
                          <ValidationRule type='required' message='Requerido' />
                        </Column>

                        <Column
                          dataField='Mab_Interpretacion'
                          caption='Estado'
                          width={120}
                          allowEditing={false}
                          cellRender={(cellData: any) => {
                            const valor = cellData.value;
                            if (!valor) {
                              return <span style={{ color: '#999', fontStyle: 'italic' }}>Pendiente</span>;
                            }
                            const colores = {
                              S: { bg: '#d4edda', text: '#155724', label: 'Sensible' },
                              I: { bg: '#fff3cd', text: '#856404', label: 'Intermedio' },
                              R: { bg: '#f8d7da', text: '#721c24', label: 'Resistente' },
                            };
                            const estilo = colores[valor] || { bg: '#e2e3e5', text: '#383d41', label: valor };
                            return (
                              <span
                                style={{
                                  padding: '4px 8px',
                                  borderRadius: '4px',
                                  fontSize: '12px',
                                  fontWeight: 500,
                                  backgroundColor: estilo.bg,
                                  color: estilo.text,
                                }}>
                                {estilo.label}
                              </span>
                            );
                          }}
                        />

                        <Column dataField='Mab_ComentarioExperto' caption='Comentarios' width={200} />
                        <Column type='buttons' width={80} buttons={['delete']} />
                      </DataGrid>

                      {(!resultadoMicro?.Microorganismos?.find((m: any) => m.Mmo_Id === selectedMicroorganismoId)?.Antibiograma || resultadoMicro.Microorganismos.find((m: any) => m.Mmo_Id === selectedMicroorganismoId).Antibiograma.length === 0) && (
                        <div
                          style={{
                            textAlign: 'center',
                            padding: '40px',
                            color: '#999',
                            backgroundColor: '#f9f9f9',
                            borderRadius: '8px',
                            marginTop: '20px',
                          }}>
                          No hay antibióticos registrados para este microorganismo.
                          <br />
                          <small style={{ fontSize: '12px' }}>Si tiene configurado un panel de antibióticos, se agregará automáticamente al guardar el microorganismo.</small>
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        textAlign: 'center',
                        padding: '60px',
                        color: '#999',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '8px',
                      }}>
                      <div style={{ fontSize: '48px', marginBottom: '15px' }}>🔬</div>
                      <div style={{ fontSize: '16px', fontWeight: 500, marginBottom: '8px' }}>Seleccione un microorganismo</div>
                      <div style={{ fontSize: '14px' }}>Vaya a la pestaña de IDENTIFICACIÓN y seleccione el microorganismo para el cual desea reportar el antibiograma</div>
                    </div>
                  )}
                </div>
              )}

              {currentTab === 4 && (
                <div>
                  <h4 style={{ marginBottom: '15px' }}>INFORMES GENERADOS</h4>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      marginBottom: '10px',
                      padding: '10px',
                      backgroundColor: resultadoMicro?.Rmi_EstadoGeneral === 3 ? '#d4edda' : '#fff3cd',
                      borderRadius: '8px',
                      border: `1px solid ${resultadoMicro?.Rmi_EstadoGeneral === 3 ? '#c3e6cb' : '#ffeeba'}`,
                    }}>
                    <i className={resultadoMicro?.Rmi_EstadoGeneral === 3 ? 'dx-icon-check' : 'dx-icon-clock'} style={{ fontSize: '24px', color: resultadoMicro?.Rmi_EstadoGeneral === 3 ? '#28a745' : '#ffc107' }} />
                    <div>
                      <strong>Estado del Resultado:</strong> {resultadoMicro?.Rmi_EstadoGeneral === 3 ? 'Validado' : 'Pendiente de Validación'}
                    </div>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                    <p style={{ marginBottom: '10px', color: '#666', fontSize: '14px' }}>Valide el resultado completo antes de generar el reporte final. Esta acción marca el resultado como completado.</p>

                    <Button
                      style={{ backgroundColor: '#28a745', borderColor: '#28a745', color: 'white' }}
                      text='Validar Resultado Final'
                      icon='check'
                      type='success'
                      stylingMode='contained'
                      disabled={!Prm_ResC || resultadoMicro?.Rmi_EstadoGeneral === 3 || resultadoMicro?.Gram?.Rmi_GramEstado !== 3 || resultadoMicro?.Cultivo?.Rmi_CultivoEstado !== 3}
                      onClick={handleValidarFinal}
                      hint={resultadoMicro?.Rmi_EstadoGeneral === 3 ? 'El resultado ya está validado' : resultadoMicro?.Gram?.Rmi_GramEstado !== 3 ? 'Debe validar el GRAM primero' : resultadoMicro?.Cultivo?.Rmi_CultivoEstado !== 3 ? 'Debe validar el CULTIVO primero' : 'Validar resultado completo'}
                    />

                    {resultadoMicro?.Rmi_EstadoGeneral === 3 && <div style={{ marginTop: '10px', color: '#28a745', fontSize: '14px' }}>✓ Resultado validado correctamente</div>}
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      marginBottom: '20px',
                      padding: '15px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '8px',
                    }}>
                    <Button
                      text='Generar Preliminar 1'
                      icon='plus'
                      type='default'
                      stylingMode='contained'
                      disabled={!Prm_ResC || reportes.some((r) => r.Rmr_TipoReporte === 'Preliminar1') || resultadoMicro?.Gram?.Rmi_GramEstado !== 3}
                      onClick={() => handleGenerarReporteManual('Preliminar1')}
                      hint={reportes.some((r) => r.Rmr_TipoReporte === 'Preliminar1') ? 'Ya existe este reporte' : resultadoMicro?.Gram?.Rmi_GramEstado !== 3 ? 'Debe validar el GRAM primero' : 'Generar reporte preliminar 1 (GRAM + Cultivo si disponible)'}
                    />

                    <Button
                      text='Generar Preliminar 2'
                      icon='plus'
                      type='default'
                      stylingMode='contained'
                      visible={Prm_ResC && configuracion?.Mcf_TiempoReportePreliminar2 != null && configuracion.Mcf_TiempoReportePreliminar2 > 0}
                      disabled={!Prm_ResC || reportes.some((r) => r.Rmr_TipoReporte === 'Preliminar2') || resultadoMicro?.Cultivo?.Rmi_CultivoEstado !== 3 || !resultadoMicro?.Microorganismos?.some((m) => m.Mmo_EstadoIdentificacion >= 2)}
                      onClick={() => handleGenerarReporteManual('Preliminar2')}
                      hint={reportes.some((r) => r.Rmr_TipoReporte === 'Preliminar2') ? 'Ya existe este reporte' : resultadoMicro?.Cultivo?.Rmi_CultivoEstado !== 3 ? 'Debe validar el CULTIVO primero' : !resultadoMicro?.Microorganismos?.some((m) => m.Mmo_EstadoIdentificacion >= 2) ? 'Debe tener al menos un microorganismo con identificación confirmada' : 'Generar reporte preliminar 2 (+ Identificación)'}
                    />

                    <Button
                      text='Generar Final'
                      icon='check'
                      type='success'
                      stylingMode='contained'
                      disabled={!Prm_ResC || reportes.some((r) => r.Rmr_TipoReporte === 'Final') || resultadoMicro?.Rmi_EstadoGeneral !== 3 || !resultadoMicro?.Microorganismos?.every((m) => m.Mmo_AntibiogramaEstado === 3)}
                      onClick={() => handleGenerarReporteManual('Final')}
                      hint={reportes.some((r) => r.Rmr_TipoReporte === 'Final') ? 'Ya existe el reporte final' : resultadoMicro?.Rmi_EstadoGeneral !== 3 ? 'Debe validar el resultado completo' : !resultadoMicro?.Microorganismos?.every((m) => m.Mmo_AntibiogramaEstado === 3) ? 'Todos los microorganismos deben tener antibiograma validado' : 'Generar reporte final completo'}
                    />
                  </div>

                  <DataGrid key={reportesKey} dataSource={reportes} showBorders={true} columnAutoWidth={true} allowColumnReordering={true} columnWidth={'auto'}>
                    <Column dataField='Rmr_NumeroReporte' caption='#' width={60} />
                    <Column dataField='Rmr_TipoReporte' caption='Tipo de Reporte' width={150} />
                    <Column dataField='Rmr_HorasTranscurridas' caption='Horas' width={80} customizeText={(e) => `${e.value}h`} />
                    <Column dataField='Rmr_FechaGeneracion' caption='Fecha Generación' dataType='datetime' format='dd/MM/yyyy HH:mm' width={160} />
                    <Column
                      caption='Origen'
                      width={120}
                      cellRender={(data) => (
                        <span
                          style={{
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                          }}>
                          {data.data.Rmr_Us_IdCreacion === 0 ? 'Auto' : 'Manual'}
                        </span>
                      )}
                    />
                    <Column dataField='Rmr_Reportado' caption='Reportado' dataType='boolean' width={100} visible={false} />
                    <Column dataField='Rmr_Impreso' caption='Impreso' dataType='boolean' width={100} />
                    <Column
                      caption='Acciones'
                      type='buttons'
                      width={150}
                      buttons={[
                        {
                          hint: 'Ver reporte',
                          icon: 'eyeopen',
                          onClick: (e: any) => handleVerReporte(e.row.data),
                        },
                      ]}
                    />
                  </DataGrid>
                </div>
              )}
            </div>
          </div>
        </ScrollView>
      )}
      <ReportMicrobiology visible={modalReporteVisible} setvisible={setModalReporteVisible} reporte={reporteSeleccionado} />
    </Popup>
  );
};
